import React, { useCallback, useEffect, useState } from 'react'
import Footer from '../../components/Footer'
import Navbar from '../../components/Home/Navbar'
import { PostSkeleton } from '../../components/Widgets/CustomSkeleton'
import PostCard from '../../components/Widgets/PostCard'
import { findAll } from '../../services/blog'
import { blogNavLinks } from '../../utilities/links'
import { dummyPosts } from '../../utilities/post'

const All = () => {
	const [posts, setPosts] = useState(dummyPosts)
	const [isLoading, setIsLoading] = useState(true);

	const getPosts = useCallback(async () => {
		setIsLoading(true);
		const res = await findAll()

		if (res[0]) {
			setPosts(res);
			setIsLoading(false);
		} else {
			setTimeout(() => {
				getPosts();
			}, 2000);
		}
	}, [],)

	useEffect(() => {
		getPosts()
	}, [getPosts])
	return (
		<>
			<Navbar filled links={blogNavLinks} />
			<section id="recentPost" className="dark:bg-slate-900 pb-10 pt-20 app-x">
				<div className="flex justify-between items-center py-5 flex-wrap">
					<h3 className='font-serif text-slate-700 mr-3 font-extrabold dark:text-white text-2xl'>
						<span>All Posts</span>
					</h3>
				</div>
				<div className="grid gap-10 grid-cols-1 sm:grid-cols-2 md:grid-cols-3">
					{posts.map((each, i) => (
						isLoading ? <PostSkeleton key={i} /> :
							<PostCard data={each} responsive key={i} />
					))}
				</div>
			</section >
			<Footer />
		</>
	)
}

export default All